import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createPartnerAccountant } from '../../api/partner-accountant.ts';
import type { CreatePartnerAccountantRequest } from '../../api/requests/partner-accountant-request.ts';

export default function useCreatePartnerAccountant(): UseMutationResult<
  string,
  Error,
  CreatePartnerAccountantRequest
> {
  return useMutation({
    mutationFn: createPartnerAccountant,
  });
}
